import makeActionCreator from './makeActionCreator';
import {
  FETCH_RESPONSES_IF_NEEDED,
  USE_CACHED_RESPONSES,
  STORE_RESPONSES_CACHE,
  FETCH_NOTEWORTHY_ERROR,
  FETCH_NOTEWORTHY_SUCCESS,
  FETCH_RESPONSES,
  FETCH_RESPONSES_DONE,
  FETCH_RESPONSES_ERROR,
  FETCH_RESPONSES_LOADING,
  FETCH_RESPONSES_SUCCESS,
  UPDATE_NOTEWORTHY_RESPONSES,
  UPDATE_NOTEWORTHY_RESPONSES_DONE,
  UPDATE_NOTEWORTHY_RESPONSES_ERROR,
  UPDATE_NOTEWORTHY_RESPONSES_LOADING,
  UPDATE_NOTEWORTHY_RESPONSES_SUCCESS
} from './actionTypes';

// Create your Action Creators here...
export const fetchResponses = makeActionCreator(FETCH_RESPONSES, 'eventId');
export const fetchResponsesLoading = makeActionCreator(FETCH_RESPONSES_LOADING);
export const fetchResponsesSuccess = makeActionCreator(FETCH_RESPONSES_SUCCESS, 'responses');
export const fetchResponsesError = makeActionCreator(FETCH_RESPONSES_ERROR, 'error');
export const fetchResponsesDone = makeActionCreator(FETCH_RESPONSES_DONE);

// Cache-aware actions
export const fetchResponsesIfNeeded = makeActionCreator(FETCH_RESPONSES_IF_NEEDED, 'eventId');
export const applyCachedResponses = makeActionCreator(USE_CACHED_RESPONSES, 'eventId', 'data');
export const storeResponsesCache = makeActionCreator(STORE_RESPONSES_CACHE, 'eventId', 'data', 'fetchedAt');

export const fetchNoteworthySuccess = makeActionCreator(FETCH_NOTEWORTHY_SUCCESS,
  'responses');
export const fetchNoteworthyError = makeActionCreator(FETCH_NOTEWORTHY_ERROR, 'error');

export const updateNoteworthyResponses = makeActionCreator(UPDATE_NOTEWORTHY_RESPONSES, 'eventId',
  'postIds');
export const updateNoteworthyResponsesLoading = makeActionCreator(
  UPDATE_NOTEWORTHY_RESPONSES_LOADING);
export const updateNoteworthyResponsesSuccess = makeActionCreator(
  UPDATE_NOTEWORTHY_RESPONSES_SUCCESS, 'responses');
export const updateNoteworthyResponsesError = makeActionCreator(UPDATE_NOTEWORTHY_RESPONSES_ERROR,
  'error');
export const updateNoteworthyResponsesDone = makeActionCreator(UPDATE_NOTEWORTHY_RESPONSES_DONE);
